import React, { useEffect, useState } from 'react';

const BLOG_ID = '6212027078150267545';
const API_KEY = 'AIzaSyAa-gznG7JFufNMqmiumCsheVbt9-8IddM';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/blogger/v3/blogs/${BLOG_ID}/posts?key=${API_KEY}&maxResults=5`
        );
        if (!response.ok) throw new Error('Failed to fetch posts');
        const data = await response.json();
        setPosts(data.items || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (loading) return <div>Loading blog posts...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div
      className="blog-page"
      style={{
        maxWidth: 800,
        margin: '0 auto',
        padding: 20,
        height: '80vh', // Set a fixed height
        overflowY: 'auto', // Enable vertical scrolling
        background: '#f7f7f7',
        borderRadius: 16,
        boxSizing: 'border-box',
      }}
    >
      <h2>Latest Blog Posts</h2>
      {posts.length === 0 && <p>No posts found.</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
        {posts.map((post, idx) => (
          <div
            key={post.id}
            className="blog-card"
            style={{
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              borderRadius: 12,
              background: '#fff',
              padding: 28,
              marginTop: idx === 0 ? 80 : 0,
              border: '1px solid #eaeaea',
              transition: 'box-shadow 0.2s',
            }}
          >
            <h3 style={{ marginTop: 0 }}>{post.title}</h3>
            <div style={{ margin: '18px 0' }} dangerouslySetInnerHTML={{ __html: post.content }} />
            <p style={{ color: '#888', fontSize: 14, marginBottom: 0 }}>
              Published: {new Date(post.published).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
